import Api from './Api';

const END_POINT = "inventories";

export default {
  async get_all(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}`, request);
  },
  get_reactive_all(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/reactive`, request);
  },
  get_material_all(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/material`, request);
  },
  async get_material_allPaginated(filters = null) {
    let request = {
        params: filters
    }
    return await Api.get(`${END_POINT}/material-list-paginated`, request);
  },
  async get_reactive_allPaginated(filters = null) {
    let request = {
        params: filters
    }
    return await Api.get(`${END_POINT}/reactive-list-paginated`, request);
  },
  list(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/list`, request);
  },
  listReactivos(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/listReactivos`, request);
  },
  availability(product_id) {
    return Api.get(`${END_POINT}/${product_id}/availability`);
  },

  async show(inventory) {
    return await Api.get(`${END_POINT}/${inventory.id}`);
  },
  async showById(inventory) {
    return await Api.get(`${END_POINT}/byidProduct/${inventory}`);
  },
  async showByIdProduct(product) {
    return await Api.get(`products/byidProduct/${product}`);
  },
  async get_imeis(inventory, filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}/${inventory.id}/list-imeis`, request);
  },

  async getImeisChips() {
    return await Api.get(`${END_POINT}/imeis-chips`);
  },

  async catalogue(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}/get-catalogue`, request);
  },

  async convert(data) {
    return await Api.post(`${END_POINT}/convert`, data);
  },

  async storeNewStock(data) {
    return await Api.post(`${END_POINT}/new-stock`, data);
  },

  async storeDomesticConsumption(data) {
    return await Api.post(`${END_POINT}/domestic-consumption`, data);
  },

  async storeDecrease(data) {
    return await Api.post(`${END_POINT}/decrease`, data);
  },

  async storeDecreaseTesting(data) {
    return await Api.post(`${END_POINT}/decrease-testing`, data);
  },
  async storeIncreaseTesting(data) {
    return await Api.post(`${END_POINT}/increase-testing`, data);
  },
  download(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/download`, request);
  },

  async catalogueToSale(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}/get-catalogue-to-sale`, request);
  },

  getProductsToTransfer(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/get-products-to-transfer`, request);
  },

  async getProductsFromOffice(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}/get-products-from-office`, request);
  },
};
